import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sheetHeaders: [],
  selectedSheetDetails: [],
  sheetData: [],
  selectedTemplate: null,
}

export const feedbackInfoSlice = createSlice({
  name: 'feedbackInfo',
  initialState,
  reducers: {
    // Update sheetHeaders with an array of header keys
    setSheetHeaders: (state, action) => {
      state.sheetHeaders = action.payload
    },
    // Update selectedSheetDetails with matching sheet object(s)
    setSelectedSheetDetails: (state, action) => {
      state.selectedSheetDetails = action.payload
    },
    // Set sheet data from consolidated file
    setSheetData: (state, action) => {
      state.sheetData = action.payload
    },
    // Set selected template
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload
    },
    // Set data to initial state
    resetFeedbackInfo: () => {
      return initialState
    },
  },
})

export const { setSheetHeaders, setSelectedSheetDetails, setSheetData, setSelectedTemplate, resetFeedbackInfo } =
  feedbackInfoSlice.actions

export default feedbackInfoSlice.reducer
